export enum ArchiveOrderKindEnum {
  Unknown = -1,
  ShopPortal = 0,
  BrightMotive = 1,
  VrooamShop = 2,
  WinCar_FourceNoord = 3,
  ShopPortalThirdPartyApi = 4,
  EasyCloudShopApi = 5,
  Mijngrossier = 6
}